import axios from 'axios'

export const companiesAccessibleApi = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
    message: null,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readAccessibleApiSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    getErrorResponse(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors.response.data.errors[0].detail
    },
  },
  getters: {
    isAdmin(state) {
      return state.data?.meta?.admin_role === 'admin'
    },
    isDistributer(state) {
      return state.data?.meta?.admin_role === 'distributer'
    },
    showOnlyOwnerAuthority(state) {
      return state.data?.meta?.role === 'owner'
    },
    showOnlyEditorOrOperatorAuthority(state) {
      return (state.data?.meta?.role === 'editor' || state.data?.meta?.role === 'operator')
    },
    showMoreThanEditorAuthority(state) {
      switch (state.data?.meta?.role) {
      case 'owner':
        return true
      case 'editor':
        return true
      default:
        return false
      }
    },
    showMoreThanOperatorAuthority(state) {
      switch (state.data?.meta?.role) {
      case 'owner':
        return true
      case 'editor':
        return true
      case 'operator':
        return true
      default:
        return false
      }
    },
    canCreatePostAuthority(state, getters, rootState) {
      if (rootState.companiesAccessibleApi.data.data['biz/api/companies/posts']) {
        return rootState.companiesAccessibleApi.data.data['biz/api/companies/posts'].includes('create')
      } else {
        return false
      }
    },
    canDeletePostAuthority(state, getters, rootState) {
      if (rootState.companiesAccessibleApi.data.data['biz/api/companies/posts']) {
        return rootState.companiesAccessibleApi.data.data['biz/api/companies/posts'].includes('destroy')
      } else {
        return false
      }
    },
    canReplyAuthority(state, getters, rootState) {
      if (rootState.companiesAccessibleApi.data.data['biz/api/companies/reviews/replies']) {
        return rootState.companiesAccessibleApi.data.data['biz/api/companies/reviews/replies'].includes('create')
      } else {
        return false
      }
    },
    canExportAuthority: (state, getters, rootState) => (recordType) => {
      if (rootState.companiesAccessibleApi.data.data[`biz/api/companies/export/${recordType}`]) {
        return rootState.companiesAccessibleApi.data.data[`biz/api/companies/export/${recordType}`].includes('create')
      } else {
        return false
      }
    },
  },
  actions: {
    readAccessibleApi({ commit }, companyUuid) {
      commit('apiConnect')
      return axios
        .get('/api/companies/' + companyUuid + '/accessible_api.json')
        .then(res => {
          commit('readAccessibleApiSuccess', res.data)
        })
        .catch(err => {
          commit('getErrorResponse', err)
          console.error(err)
        })
    },
  }
}
